import * as React from 'react';
import { ListSubheader, IconButton } from '@mui/material';
import { Add } from '@mui/icons-material';

interface Props {
    title: string;
    onNewClick: (e: any)=> void;
}

export const ListSubheaderWithButtons = (props: Props) => {
    return (
        <ListSubheader>
            {props.onNewClick!=null && <IconButton style={{"float": "right"}} onClick={props.onNewClick} size="large">
                <Add />
        </IconButton>}{props.title}</ListSubheader>
    );
}